// extracted by mini-css-extract-plugin
module.exports = {"inputFiled":"_1vi-d","label":"_2Y6as"};